import { useState, useEffect, useRef } from "react";
import { FaRegCopy } from "react-icons/fa";
import { useAnimation } from "framer-motion";
import { useCTA } from "../../../context/CTAContext";
const SignupOffer = ({ data, scrolled }) => {
  const [copied, setCopied] = useState(false); // eslint-disable-next-line
  const [isOpen, setIsOpen] = useState(false);
  const claimPulse = useAnimation();
  const wrapperRef = useRef(null);
  const { setCTAHeight } = useCTA();

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!data?.promoCode) return;
    try {
      await navigator.clipboard.writeText(data.promoCode);
      setCopied(true);
      claimPulse.start({
        scale: [1, 1.05, 1],
        transition: { duration: 0.8, repeat: 2, ease: "easeInOut" },
      });
      setTimeout(() => setCopied(false), 900);
    } catch {}
  };

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;
    const setH = () => {
      const h = el.offsetHeight || el.getBoundingClientRect().height || 0;
      setCTAHeight(h);
    };
    setH();
    window.addEventListener("resize", setH);
    return () => window.removeEventListener("resize", setH);
  }, [setCTAHeight]);
  return (
    <div
      ref={wrapperRef}
      className={` ${
        scrolled ? " px-32 " : "rounded-2xl"
      } bg-[#0C1220] dark:bg-[#1e2430] text-white flex flex-col md:flex-row justify-between items-center gap-8  p-8 border border-gray-400 dark:border-gray-600 transition-colors duration-300 mt-10 mx-auto px-5  `}
    >
      {/* Left Section with Logo + Text */}
      <div className="flex items-center gap-10">
        {/* Logo */}
        <div className="w-[200px]">
          <img
            src={data?.logoUrl}
            alt="Casino Logo"
            className="w-full rounded-2xl object-cover flex-shrink-0"
          />
        </div>

        {/* Text Content */}
        <div className="flex flex-col justify-center text-left -ml-2">
          <p className="text-sm tracking-widest text-gray-300 dark:text-gray-400 mb-2 camelcase">
            Sign up offer
          </p>
          <h2 className="text-2xl font-bold mb-2 leading-snug text-white dark:text-white">
            {data?.title}
          </h2>
          <p className="text-gray-400 dark:text-gray-300 leading-relaxed">
            {data?.description}
          </p>
        </div>
      </div>
      <div className="flex gap-4">
        {data?.promoCode && data.promoCode !== "N/A" && !isOpen && (
          <div className="relative  " onMouseDown={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={handleCopy}
              className="bg-white  text-gray-900 dark:bg-gray-100 dark:text-gray-900 font-medium px-7 py-2.5 rounded-md flex items-center justify-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-200 transition whitespace-nowrap no-underline hover:no-underline"
              title="Copy promo code"
            >
              {data?.promoCode || "N/A"}
              <FaRegCopy className="opacity-80" />
              {copied && !isOpen && (
                <span className="absolute bottom-12 right-4 text-[11px] px-2 py-0.5 rounded bg-text dark:border-none  dark:bg-gray-800 text-white">
                  Copied
                </span>
              )}
            </button>
          </div>
        )}
        {/* Right Button */}
        <a
          rel="noreferrer"
          href={data.link}
          target="_blank"
          className="bg-white text-gray-900 dark:bg-gray-100 dark:text-gray-900 font-medium px-7 py-2.5 rounded-md flex items-center justify-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-200 transition whitespace-nowrap no-underline hover:no-underline"
        >
          Play Now
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 transform -rotate-45"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default SignupOffer;
